/**
 * Tek doğruluk kaynağı: iletişim numaraları & sosyal kanallar.
 *
 * Tüm site bu sabitleri kullanır. Değişiklik gerekirse sadece burası güncellenir,
 * tüm WhatsApp linkleri, contact form'lar ve destek sayfaları otomatik senkronize olur.
 */

// E.164 format (sadece rakam, ülke kodu dahil) — WhatsApp link API için
export const WHATSAPP_NUMBER_RAW = '905337206282';

// Görüntüleme formatı (kullanıcıya gösterilirken)
export const WHATSAPP_NUMBER_DISPLAY = '+90 533 720 62 82';
export const PHONE_DISPLAY = '0533 720 62 82';

/**
 * WhatsApp deep-link üreticisi.
 * @param {string} message - Önceden doldurulmuş mesaj (opsiyonel)
 * @returns {string} https://wa.me/... URL
 */
export function buildWhatsAppUrl(message = '') {
  const base = `https://wa.me/${WHATSAPP_NUMBER_RAW}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
